// extracted by mini-css-extract-plugin
export var SectionContainer = "index-module--SectionContainer--a6L8c";
export var SectionContainerTitle = "index-module--SectionContainerTitle--v93yr";
export var SectionSubstanceBody = "index-module--SectionSubstanceBody--qziTc";